<template>
	<div id="activity_settlement">
		<van-tabs v-model="active">
			<van-tab title="未结算">
				<div style="width: 100%;height: auto;margin-top: 5px;" v-for="(item,index) in list2">
					<div style="display: flex;height: auto;background-color: white;border: 1px solid #e8e8e8;margin-bottom: 5px;">
						<div style="width: 80px;" @click="user(item.userId)">
							<img :src="item.photo|addPath" style="height: auto;width: 80%;margin: 10%;" />
						</div>
						<div style="flex: 2;font-size: 14px;">
							<p style="margin: 8px 0px;">用户名 : {{item.userName}} </p>
							<p style="margin: 5px 0px;">联系电话 : {{item.phone}}</p>
							<p style="margin: 5px 0px;">签到次数 : <span style="color: #ff4500;">{{item.signCount}}</span></p>
							服务时数：<input v-model.number="serverTimes[index]" type="number" style="width: 20%;border: 1px solid #e2e1e1;border-radius: 5px;"> 能量值：<input type="number" v-model.number="serverPoints[index]" style="width: 20%;border: 1px solid #e2e1e1;border-radius: 5px;">
						</div>
						<div>
							<van-checkbox style="margin: 30px 10px;" v-model="checks[index]"></van-checkbox>
						</div>
					</div>
				</div>
				<van-submit-bar button-text="结算项目" @submit="confirm()">
					<div @click="check()" style="margin-left: 10px;">
						<van-checkbox v-model="checked">全选</van-checkbox>
					</div>
				</van-submit-bar>
			</van-tab>
			<van-tab title="已结算">
				<div style="width: 100%;height: auto;margin-top: 5px;" v-for="(item,index) in list">
					<div style="display: flex;height: auto;background-color: white;border: 1px solid #e8e8e8;margin-bottom: 5px;">
						<div style="width: 80px;" @click="user(item.userId)">
							<img :src="item.photo|addPath" style="height: auto;width: 80%;margin: 10%;" />
						</div>
						<div style="flex: 2;font-size: 14px;">
							<p style="margin: 8px 0px;">用户名 : {{item.userName}} </p>
							<p style="margin: 5px 0px;">联系电话 : {{item.phone}}</p>
							<p style="margin: 5px 0px;">签到次数 : <span style="color: #ff4500;">{{item.signCount}}</span></p>
						</div>
					</div>
				</div>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import { Cell, CellGroup, Dialog, Pagination, NavBar, Popup, Search, Loading, Toast, Icon, Area, Picker, Button, Tab, Tabs, List, PullRefresh, SubmitBar, Checkbox, CheckboxGroup } from 'vant';
	import axios from 'axios';
	import store from '@/store/store.js';
	import global from '@/api/global';
	import { htmlspecialchars_decode, formatDate } from '@/js/common.js';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	import areaList from '@/js/area.js';
	Vue.use(VueCookies);
	export default {
		filters: {
			formatDate(time) {
				return formatDate(time, 'yyyy-MM-dd hh:mm:ss');
			},
			addPath(path) {
				return global.resoursePhoto + "/" + path;
			}
		},
		components: {
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Dialog.name]: Dialog,
			[Pagination.name]: Pagination,
			[NavBar.name]: NavBar,
			[Popup.name]: Popup,
			[axios.name]: axios,
			[Search.name]: Search,
			[Loading.name]: Loading,
			[Toast.name]: Toast,
			[Icon.name]: Icon,
			[Area.name]: Area,
			[Picker.name]: Picker,
			[Button.name]: Button,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
			[SubmitBar.name]: SubmitBar,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
		},
		data() {
			return {
				active: 0,
				list: [],
				list2: [],
				checks: [],
				checked: false,
				serverPoint: 0,
				serverTime: 0,
				serverPoints: [],
				serverTimes: []
			}
		},
		created: function() {
			this.serverPoint = this.$route.query.serverPoint;
			this.serverTime = this.$route.query.serverTime;
			this.settlement();
			this.settlement2();
		},
		methods: {
			user(id) {
				this.$router.push({
					path: '/user_info', //跳转的路径
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						id: id
					}
				});
			},
			check() {
				for(var i = 0; i < this.checks.length; i++) {
					this.$set(this.checks, i, this.checked);
				}
				console.log(this.checks);
			},
			confirm() {
				Toast.loading({
					mask: true,
					message: '提交中...',
					duration: 0
				});
				for(var i = 0; i < this.checks.length; i++) {
					if(this.checks[i] == true) {
						axios({
							method: 'post',
							url: global.baseURL + 'appsite/attend/settlement',
							params: {
								id: this.list2[i].id,
								serviceTime: this.serverTimes[i],
								serverPoint: this.serverPoints[i],
								auth_token: this.$cookies.get("auth_token")
							}
						}).then((resp) => {

						}).catch(resp => {});
					}
				}
				Toast.clear();
				Toast.success("结算成功");
				setTimeout(() => {
					this.$router.go(0);
				}, 1000);
			},
			settlement() { //已结算
				this.list = [];
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/attend/selectAll',
					params: {
						projectId: this.$route.query.id,
						status: 4,
					}
				}).then((resp) => {
					this.list = resp.data.data;
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			settlement2() { //未结算
				this.list2 = [];
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/attend/selectAll',
					params: {
						projectId: this.$route.query.id,
						status: 2
					}
				}).then((resp) => {
					this.list2 = resp.data.data;
					for(var i = 0; i < this.list2.length; i++) {
						this.checks.push(false);
						this.serverPoints.push(this.serverPoint);
						this.serverTimes.push(this.serverTime);
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					console.log(resp)
					Toast.fail('请求失败');
				});
			}
		}
	}
</script>

<style>
	#admin_add p {
		font-size: 12px;
		margin: 10px;
		color: gray;
	}
	
	#examine_act p {
		font-size: 12px;
		margin: 10px;
		color: gray;
	}
	
	#activity_settlement .admin_p {
		white-space: normal;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		font-size: 14px;
		margin: 4px;
		margin-left: 10px;
		margin-top: 10px;
	}
	
	#activity_settlement .admin_date {
		font-size: 10px;
		color: gray;
		margin-left: 10px;
		margin-bottom: 10px;
	}
	
	#admin_add .van-button {
		margin: 10px auto;
		color: white;
		width: 90%;
		margin-left: 5%;
		border-radius: 5px;
	}
	
	#activity_settlement .admin_details {
		border-bottom: 1px solid #f7f5f5;
		width: 100%;
		height: auto;
		min-height: 80px;
		display: flex;
	}
	
	#activity_settlement .active_button {
		background-color: orangered !important
	}
	
	#activity_settlement .org_item {
		margin: 10px 5%;
	}
	
	#org_content * {
		width: auto;
		height: auto;
		max-width: 100%;
	}
	
	#activity_settlement .org_span {
		vertical-align: middle;
		margin-left: 6px;
	}
	#activity_settlement .van-tab__pane{
		margin-bottom: 50px;
	}
	/*#activity_settlement .van-icon,
	#activity_settlement .van-icon::before {
		vertical-align: middle;
	}*/
</style>